import { render } from "./LoginSuperAdmin.vue?vue&type=template&id=8f6bbef2&scoped=true"
import script from "./LoginSuperAdmin.vue?vue&type=script&lang=js"
export * from "./LoginSuperAdmin.vue?vue&type=script&lang=js"

import "./LoginSuperAdmin.vue?vue&type=style&index=0&id=8f6bbef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6bbef2"]])

export default __exports__